import React from 'react';
import I18n from 'i18n-js';
import { RCIcon, RCPopover } from '@reverbdotcom/cadence/components';
import { BellIcon } from '@reverbdotcom/cadence/icons/react';
import { useNotificationsBellCount } from './notifications_bell_count_hook';

export default function NotificationsCenterPopover() {
  const { count } = useNotificationsBellCount();

  return (
    <RCPopover
      position="bottom-end"
      anchor={(
        <button
          type="button"
          className="reverb-header__nav__link reverb-header__nav__link--notification-icon"
        >
          <div
            className="reverb-header__nav__link__icon"
            data-notification-count={count || null}
          >
            <RCIcon icon={<BellIcon />} />
          </div>
          <div className="reverb-header__nav__link__label">
            {I18n.t('discovery.reverbHeader.notifications')}
          </div>
          <span className="reverb-header__count-badge">
            {count > 0 && I18n.t('discovery.reverbHeader.notificationCount', { count })}
          </span>
        </button>
      )}
    >
      <div className="notifications-center__placeholder" />
    </RCPopover>
  );
}
